import { differenceInMinutes, format } from "date-fns";
import { TFunction } from "i18next";

export function getCurrentDatetimeStr() {
    return format(new Date(), "yyyy-MM-dd HH:mm");
}

export function getCurrentDatetimeWithCorrectionMin(minutes: number) {
    const date = new Date();
    date.setMinutes(date.getMinutes() + minutes);
    return format(date, "yyyy-MM-dd HH:mm");
}

export function getCurrentDatetimeWithCorrectionYears(years: number) {
    const date = new Date();
    date.setFullYear(date.getFullYear() + years);
    return format(date, "yyyy-MM-dd HH:mm");
}

export function getNormalizedDate(dateTimeStr: string) {
    const dateTime = new Date(dateTimeStr);
    return `${String(dateTime.getDate()).padStart(2, "0")}.${String(
        dateTime.getMonth() + 1
    ).padStart(2, "0")}.${dateTime.getFullYear()}`;
}

export function getNormalizedTime(dateTimeStr: string) {
    const dateTime = new Date(dateTimeStr);
    return `${String(dateTime.getHours()).padStart(2, "0")}:${String(
        dateTime.getMinutes()
    ).padStart(2, "0")}`;
}

export function getNormalizedTimeAndDate(dateTimeStr: string | null | undefined) {
    if (!dateTimeStr) return "-";
    const dateTime = new Date(dateTimeStr);
    if (Number.isNaN(dateTime.getTime())) return "-";
    return `${String(dateTime.getHours()).padStart(2, "0")}:${String(
        dateTime.getMinutes()
    ).padStart(2, "0")} ${String(dateTime.getDate()).padStart(2, "0")}.${String(
        dateTime.getMonth() + 1
    ).padStart(2, "0")}.${dateTime.getFullYear()}`;
}

export function getCreatedTime(
    t: TFunction,
    startStr: string,
    context = "default"
) {
    const start = new Date(startStr);
    const finish = new Date();
    const diffMs = finish.getTime() - start.getTime();

    const diffMinutes = Math.floor(diffMs / 60000);
    if (diffMinutes < 60) {
        return t("common.diffMinutes", { diffMinutes, context });
    }

    const hours = Math.floor(diffMinutes / 60);
    if (hours < 24) {
        return t("common.diffHours", { hours, context });
    }

    const diffDays = Math.floor(hours / 24);
    if (diffDays < 30) {
        return t("common.diffDays", { diffDays, context });
    }

    const diffMonths = Math.floor(diffDays / 30);
    if (diffMonths < 12) {
        return t("common.diffMonths", { diffMonths, context });
    }

    const diffYears = Math.floor(diffDays / 365);
    return t("common.diffYears", { diffYears, context });
}

export function getNormalizedExpiresIn(expiresIn: Date) {
    const minutes = differenceInMinutes(expiresIn, new Date());
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
}
